import { debounce } from 'lodash';
import { memo, useCallback, useEffect, useRef, useState } from 'react';

export interface TextAreaProps {
  value: string;
  autoFocus?: boolean;
  onChange: (e) => void;
  onFocus?: (e) => void;
  onBlur?: (e) => void;
  className?: string;
  readOnly?: boolean;
}

const TextArea = memo(({ value, onChange, onBlur, onFocus, className, autoFocus, readOnly }: TextAreaProps) => {
  const textAreaRef = useRef<HTMLTextAreaElement>();

  const debouncedUpdate = useCallback(
    debounce(val => onChange(val), 1000),
    [],
  );

  const updateHeight = useCallback(() => {
    textAreaRef.current.style.height = '0px';
    const scrollHeight = textAreaRef.current.scrollHeight;
    if (textAreaRef.current.style.height !== scrollHeight + 'px')
      textAreaRef.current.style.height = scrollHeight + 'px';
  }, [])

  const l_onChange = useCallback(
    event => {
      //if (event.target.value) {
      textAreaRef.current.value = event.target.value;
      updateHeight();
      debouncedUpdate(event.target.value);
      //}
    },
    [debouncedUpdate, updateHeight],
  );



  useEffect(() => {
    if (!textAreaRef.current.value && value) textAreaRef.current.value = value || '';
    updateHeight();
  }, []);

  return (
    <textarea
      autoFocus={autoFocus}
      className={`${className}`}
      onChange={l_onChange}
      onBlur={e => (onBlur ? onBlur(e) : null)}
      onFocus={e => (onFocus ? onFocus(e) : null)}
      ref={textAreaRef}
      readOnly={readOnly}
      unselectable={readOnly ? 'on' : 'off'}
      rows={1}
    />
  );
});

export default TextArea;
